import { useSyncExternalStore } from 'react';

/**
 * How loud the call's voice is now (0 to 1, about 15 times a second), kept out of React state:
 * only the call's face follows it, rather than every reader of the call rendering at that rate
 * (a page rendering that often never commits the transitions a streamed answer renders in).
 */
let level = 0;
const listeners = new Set<() => void>();

export function setCallLevel(next: number): void {
  if (next === level) return;
  level = next;
  for (const listener of listeners) listener();
}

export function useCallLevel(): number {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => level,
    () => 0,
  );
}
